import api from '@/api/index'
import { axios } from '@/utils/request'

/**
 * getTableData func
 * parameter: {
 * }
 * @param parameter
 * @returns {*}
 */
export function getTableData (parameter) {
  return axios({
    url: api.adminQuery,
    method: 'post',
    data: parameter
  })
}

/**
 * getTableData func
 * headers:{}
 * @param parameter
 * @param method
 * @param url
 * @param headers
 * @returns {*}
 */
export function getTableDataByApi (method,url,headers,parameter) {
  return axios({
    url: url,
    method: method,
    headers:headers,
    data: parameter
  })
}
